'use strict';

//=include  ../../MetricsTracker/booker/metrics.js

import BookerTracker from '../../MetricsTracker/booker/metrics';
import GlobalUtil from '../../utils/pricetravel/shared/globalUtil';

import { SearchHistory } from '../../utils/pricetravel/shared/searchHistory';
window.app.controller('BookerFlightController', controller);
import { StorageService } from '../../vue/services/StorageService';
controller.$inject = ["$scope", "$http", "$timeout", "$rootScope"];

function controller($scope, $http, $timeout, $rootScope) {
    let vm = this;
    let internal = {};
    let config = window.__pt.settings.site;
    let setting = window.__pt.settings;
    let lang = window.__pt.ln;
    let fn = window.__pt.fn;
    let defaultDate = fn.getDate()
    let _placeOrigin = window.__pt.placeOrigin || {};
    let _placeDestination = window.__pt.placeDestination || {};
    let _list = "";
    let _inputName = "";
    let _datePicker = {}
    let _picker = null;
    let tracker = new BookerTracker();
    let localeDatePicker = {
        format: setting.formatBoxDate,
        firstDay: 0, 
        applyLabel: lang.ok,
        cancelLabel: lang.cancel
    }
    vm.config = config;
    vm.error_paxes = false;
    vm.destinationEquals = false;
    vm.siteUrl = window.__pt.settings.site.siteUrl;
    vm.typeFlightSuggestion = 11;
    vm.submit = false;
    vm.years = [];
    vm.suggestion = {
        from: {
            results: [],
            show: false
        },
        to: {
            results: [],
            show: false
        },
        paxes: false
    };
    vm.hasResult = false;
    vm.algoliaUrl = "https://img.cdnpth.com/media/assets/recent-search-imgs/iatas/";
    vm.validation = {
        paxes: true,
        checkIn: true,
        checkOut: true,
        dates: true
    }
    vm.settingPaxes = {
        minAdults: 1,
        maxAdults: 9,
        minChildren: 0,
        maxChildren: 8,
        minAge: 1,
        maxAge: 11,
        totalPaxes: 9
    };

    vm.data = setting.defaultFlight;
    vm.mode = true;
    vm.placeInputHasFocus = {
        to: false,
        from: false
    };
    vm.history = {
        from: [],
        to: []
    };
    vm.showDefaultSuggestions = {
        from: false,
        to: false
    };
    let _globalUtil = new GlobalUtil();
    let _userKey = _globalUtil.getUserKey();
    let origin = null;
    let lastQuery = '';

    $rootScope.$on(setting.bookerValuesEventFlight, function (event, args) {
        vm.data = args.data;
        vm.data.checkIn = fn.getDate(vm.data.checkIn);
        vm.data.checkOut = fn.getDate(vm.data.checkOut);
        vm.onChangeFlight();

        $timeout(() => vm.onSubmit(vm.form, true), 100)
    });
    vm.onSearch = (value, list, input, focus) => {
        if (value === "" || value === null || value === undefined || value.length < 3) {
            vm.showDefaultSuggestions[list] = true;
            AlgoliaSearch(list);
        }

        if (!value || (value && value.length < 3)) {
            return;
        }
        vm.hasResult = false;

        if (vm.form[input].$valid) {
            vm.showDefaultSuggestions[list] = false;
            _inputName = focus;
            _list = list;
            const params = {
                query: value,
                language: config.language,
                placeTypes: config.placesTypeHotel,
                from: 0,
                size: config.siteName == "tiquetesbaratos" ? 5 : 10,
                usersearch: _userKey,
                site: config.code,
                version: "v2",
                analyticsTags: getAnalyticsTags()
            }
            
            $http.get(config.endPoints.suggestionFlightUrl, { params })
                .then(function tap(resp) {

                    lastQuery = params.query;

                    tracker.metricAutocompleteFlight(
                        params.query,
                        resp.data,
                        list
                    );
                    return resp;
                })
                .then(onSuccessSuggestion, onError);
        }
    }
 
    vm.onSubmit = (form) => {
        try {
            if (this.validAgeChildrenforAdult()) {
                this.showPaxes();
                return;
            }

            vm.submit = true;
            vm.validation.paxes = isValidPax(vm.data.paxes, form);
            vm.validation.checkIn = isValidDate(defaultDate, vm.data.checkIn);
            vm.validation.checkOut = isValidDate(defaultDate, vm.data.checkOut);
            vm.validation.dates = vm.data.mode ? isValidDate(vm.data.checkIn, vm.data.checkOut) : true;

            if (form.$valid && vm.validation.paxes && vm.validation.checkIn && vm.validation.checkOut && vm.validation.dates) {
                if (vm.data.place_selected.code == vm.data.place_selected_to.code) {
                    vm.destinationEquals = true;
                } else {
                    const airlinePathURL = window.location.pathname.split("/").filter(Boolean);
                    const airlineKeywords = ["aerolineas", "airlines"];
                    let landing = "";
                    const index = airlinePathURL.findIndex(segment => airlineKeywords.includes(segment));
                    if (index !== -1 && airlinePathURL[index + 1]) landing = airlinePathURL[index + 1];

                    vm.destinationEquals = false;

                    // ---- parametros de VUELOS ----
                    let paxesData = SearchHistory.mapFlightPaxQuery(vm.data.paxes);

                    let mode = vm.data.mode ? "1" : "0";

                    let data = {
                        startingFromAirport: vm.data.place_selected.code,
                        returningFromAirport: vm.data.place_selected_to.code,
                        startingFromDateTime: fn.formatDate(vm.data.checkIn, setting.formatDate),
                        returningFromDateTime: fn.formatDate(vm.data.checkOut, setting.formatDate),
                        tripMode: mode,
                        mode: mode,
                        originName: vm.data.place_name,
                        destinationName: vm.data.place_name_to
                    };
                    if (landing !== "") data.addfirst = landing;
                    data = { ...data, ...paxesData };

                    var path = config.pathFlight;

                    tracker.metricBookerFlight('booker', { vmData: vm.data, data });

                    // ---- FORM de VUELOS ----
                    var formFlight = document.createElement("form");
                    formFlight.setAttribute("method", "get");
                    formFlight.setAttribute("action", `${path}`);
                    for (var key in data) {
                        if (data[key] !== undefined && data[key] !== null && String(data[key]) !== "") {
                            var hiddenField = document.createElement("input");
                            hiddenField.setAttribute("type", "hidden");
                            hiddenField.setAttribute("name", key);
                            hiddenField.setAttribute("value", String(data[key]));
                            formFlight.appendChild(hiddenField);
                        }
                    }

                    SearchHistory.set(vm.data, "F");
                    $("#loader-page").removeClass("d-none");

                    if (config.activeTab && !config.mobile && vm.data.mode) {
                        (function openFlightsInNewTab() {
                            const flightQS = new URLSearchParams(data).toString();
                            const flightURL = `${path}?${flightQS}`;
                            window.open(flightURL, '_blank');
                        })();
                        resolvePackagesThenGoHotelsHereWithDelay();
                    } else {
                        document.body.appendChild(formFlight);
                        formFlight.submit();
                        return;
                    }
                }
            }
        } catch (e) { }
    };

    vm.onSelect = (item, type, suffix, prefix) => {
        vm.data[`place_name${suffix}`] = `${item.displayText} - ${stripHtml(item.displayDestinationHtml)} (${item.code})`;
        vm.data[`place_selected${suffix}`] = item;
        vm.suggestion[type].show = false;
        vm.placeInputHasFocus[type] = false;
        if (type === 'from') {
            origin = item.code;
        }

        tracker.metricAutocompleteFlightSelect(
            item,
            lastQuery,
            type,
            prefix
        );

        analyticsAlgolia(item, item.positions, type);
    }

    vm.showPaxes = () => {
        vm.suggestion.paxes = true;
    }

    vm.addRoom = () => {
        const paxesDefault = fn.clone(setting.defaultPaxes);
        vm.data.paxes.push(paxesDefault);
        updateInputPaxes();
    }

    vm.onFocus = (element, input) => {
        _list = element;
        _inputName = input;
        vm.hasResult = true;
        setTimeout(() => {
            AlgoliaSearch(element);
        }, 200)

        if (vm.suggestion[element]["results"].length) {
            setTimeout(() => {
                $scope.$apply(() => {
                    vm.suggestion[element]["show"] = true;
                    if (fn.mobileAndTabletCheck()) {
                        onFocusElement(`${input}_modal`)
                    }
                });
            }, 250)
        }
    }

    vm.getIcon = (type) => {
        let icon = "icons-world"//
        switch (type) {
            case 6:
                icon = "icons-world";//
                break;
            case 3:
                icon = "icons-location"; //
                break;
            case 11:
                icon = "icons-local-airport";
                break;
            case 7:
                icon = "icons-compass";//
                break;
            case 14:
                icon = "icons-bed";//
                break;
            case 12:
                icon = "icons-monument";//
                break;
        }

        return [icon]
    }


    vm.removePax = (pax, prop, minValue) => {
        if ((pax[prop] - 1) >= minValue) {
            pax[prop] -= 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();

        if (ValidTotalPaxes(pax, vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addPax = (pax, prop, maxValue) => {
        if (ValidTotalPaxes(pax, maxValue)) {
            return;
        }

        if ((pax[prop] + 1) <= maxValue) {
            pax[prop] += 1;
        }
        updateInputPaxes();
        this.validAgeChildrenforAdult();
    }


    vm.removeChildren = (pax, prop, minValue) => {
        if ((pax[prop].length - 1) >= minValue) {
            pax[prop].splice(pax[prop].length - 1, 1);
        }
        updateInputPaxes();

        if (ValidTotalPaxes(pax, vm.settingPaxes.totalPaxes)) {
            return;
        }
    }

    vm.addChildren = (pax, prop, maxValue) => {

        if (ValidTotalPaxes(pax, maxValue)) {
            return;
        }

        if ((pax[prop].length + 1) <= maxValue) {
            pax[prop].push({
                year: null
            });
        }
        updateInputPaxes();

    }

    vm.validAgeChildrenforAdult = () => {
        let paxesKeys = {};
        let adults = 0;
        let kids = 0;
        let agekids = [];
        let rooms = vm.data.paxes.length;

        for (let i = 0; i < rooms; i++) {
            const room = vm.data.paxes[i];

            adults += room.adults;

            let childrens = room.children.length;
            let childreJoin = [];
            for (let c = 0; c < childrens; c++) {
                const childrenRoom = room.children[c];
                childreJoin.push(childrenRoom.year);
                agekids.push(childrenRoom.year);
                kids += 1;
            }

        }
        paxesKeys[`adults`] = adults;
        paxesKeys[`kids`] = kids;
        paxesKeys[`agekids`] = agekids.join(",");


        let totalChildren = 0;
        if (paxesKeys[`adults`] < paxesKeys[`kids`]) {

            agekids.forEach((age, index) => {
                if (age == 1)
                    totalChildren++;
            });

            if (totalChildren > paxesKeys[`adults`]) {
                return true;
            }
            else return false;
        }
        else return false;

    }
    vm.onClose = (obj, prop, type, suffix) => {
        vm.handleCloseSuggestions(suffix);
        if (somePaxHasError()) {
            vm.form.$setSubmitted();
            return;
        }
        obj[prop] = false;
        setValidation(prop);
        vm.placeInputHasFocus[type] = false;
    }

    vm.onRemove = (obj, prop, index) => {
        obj[prop].splice(index, 1);
        updateInputPaxes();
    }


    vm.hasError = (form, property) => {
        let input = form[property];
        return form.$submitted && input.$invalid
    }


    vm.isInvalidInput = (form, inputName, position, inputNumber) => {
        return form.$submitted && form[`${inputName}_${position}_${inputNumber}`].$invalid
    }

    vm.onClickOutside = (element, prop, type, suffix) => {
        vm.placeInputHasFocus[type] = false;
        element[prop] = false;
        vm.handleCloseSuggestions(suffix);
        setValidation(prop);
    }


    vm.onChangeFlight = () => {
        initDatePicker();
    }

    vm.deleteSelection = (input, selection, type, inputFocus) => {
        vm.data[input] = null;
        vm.data[`${selection}${type.length ? '_' + type : ''}`] = {};

        onFocusElement(inputFocus);
    }

    vm.clickInputInMobile = (focus, type, suffix = "") => {
        _inputName = focus;
        vm.handleCloseSuggestions(suffix);
        if (vm.data[`place_selected${suffix}`] == null && vm.data[`place_name${suffix}`] == "") {
            vm.showDefaultSuggestions[type] = true;
            vm.onFocus(type, focus);
        }
        vm.placeInputHasFocus[type] = true;
        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
            if (vm.data.place_name && vm.data.place_name.length > 3) {
                setTimeout(() => {
                    const elem = document.getElementById(`${_inputName}_modal`)
                    if (elem) elem.setSelectionRange(0, elem.value.length);
                }, 200);
            }
        }
    }

    internal.setDataArgolia = (item, index, type) => {
        if (item && item.items && item.items.queryID && item.items.objectID && window.aa && item.items.indexName) {
            let indexName = item.items.indexName || config.algoliaSearchFlight;
            let queryid = item.items.queryID;
            let objectid = item.items.objectID;
            let position = index;
            let userToken = _userKey;
            var objectArgolia = {
                objectIDs: objectid,
                queryID: queryid,
                userToken: userToken,
                position: position,
                indexName: indexName
            }
            StorageService.setSession("_key_argo_object_flight_" + type, JSON.stringify(objectArgolia));
            window.aa('clickedObjectIDsAfterSearch', {
                userToken: userToken,
                eventName: 'Buscador Click',
                index: indexName,
                queryID: queryid,
                objectIDs: [objectid],
                positions: [position],
            });
        }
    }

    /***** Private *****/
    function resolvePackagesThenGoHotelsHereWithDelay() {

        // delay 
        $timeout(() => {
            const params = {
                query: vm.data.place_name_to,
                language: config.culture,
                placeTypes: config.placesTypePackages,
                from: 0,
                size: 1,
                site: config.code,
                destination: 1
            };

            $http.get(config.endPoints.suggestionPackageUrl, { params })
                .then(function (res) {
                    const first = (res && res.data && res.data[0]) || null;
                    const seoCode = String(first.placeCode ?? first.code).toLowerCase();
                    const seoId = (first.placeId ?? first.id);

                    // url final de hoteles 
                    const hotelBase = "/" + config.culture + "/" + __pt.culture.pathHotelList + seoCode + "_d" + seoId;
                    const hotelParams = {
                        adults: "1",
                        checkin: fn.formatDate(vm.data.checkIn, setting.formatDate),
                        checkout: fn.formatDate(vm.data.checkOut, setting.formatDate),
                        group_adults: "1",
                        no_rooms: "1"
                    };

                    const paramsQuery = fn.search();
                    if (paramsQuery.CampaignToken) {
                        hotelParams.CampaignToken = paramsQuery.CampaignToken;
                    }
                    hotelParams.ref = "flights";

                    const fullUrl = hotelBase + "?" + new URLSearchParams(hotelParams).toString();

                    window.location.assign(fullUrl); // hoteles en esta pestaña
                })
                .catch(function (err) {
                });
        }, 3000);
    }
    function ValidTotalPaxes(pax, maxValue) {
        const cantTotalt = pax['adults'] + pax['children'].length

        if (cantTotalt == vm.settingPaxes.totalPaxes) {
            vm.error_paxes = true;
            return true;
        }

        if (cantTotalt >= vm.settingPaxes.totalPaxes) {
            vm.error_paxes = true;
            return true;
        }
        else {
            vm.error_paxes = false;
            return false;
        }
    }

    function init() {
        initialDefaultDate();
        initSearchBox();
        initDatePicker();
        updateInputPaxes();
        getSearchHistory();

        for (let index = vm.settingPaxes.minAge; index <= vm.settingPaxes.maxAge; index++) {
            vm.years.push({ year: index });
        }
    }

    function onSuccessSuggestion(response) {
        const data = response.data || [];
        vm.suggestion[_list]["results"] = data;
        vm.suggestion[_list]["show"] = true;
        vm.placeInputHasFocus[_list] = true;
        if (fn.mobileAndTabletCheck()) {
            onFocusElement(`${_inputName}_modal`)
        }
    }

    function AlgoliaSearch(element) {
        const params = {
            analyticsTags: getAnalyticsTags(),
            from: 0,
            language: config.language,
            placeTypes: 0,
            site: config.code,
            size: 5,
            usersearch: _userKey,
            recommendation: true,
            origin: !!origin && element === 'to' ? origin : null,
        }
        $http.get(config.endPoints.suggestionFlightUrl, {
            params: params
        }).then(onSuccessSuggestion, onError)
    }

    function onError(response) {
        console.log(response)
    }
    vm.onClickChange = () => {
        if (vm.data.place_name && vm.data.place_name_to) {
            
            tracker.metricBookerExchangeFlights();
            const tmpPlace = vm.data.place_name;
            const tmpSelected = vm.data.place_selected;

            vm.data.place_name = vm.data.place_name_to;
            vm.data.place_selected = vm.data.place_selected_to;

            vm.data.place_name_to = tmpPlace;
            vm.data.place_selected_to = tmpSelected;
            
        }

    }

    function initSearchBox() {
        let paramsData, storageData;

        if (setting.page != 'home') {
            paramsData = getUserSelectionParams();
        } else {
            storageData = SearchHistory.getFirstEntry("F");
        }

        vm.data = paramsData || storageData || vm.data;

        if (paramsData || storageData) {
            vm.data.checkIn = fn.getDate(vm.data.checkIn);
            vm.data.checkOut = fn.getDate(vm.data.checkOut);

            if ((+vm.data.checkIn <= +defaultDate)) {
                initialDefaultDate();
            }
        }
    }

    function initDatePicker() {
        let valid = isValidDate(vm.data.checkIn, vm.data.checkOut);
        if (!valid) {
            vm.data.checkOut = getInitialDate(vm.data.checkIn, config.bookerDefaultCheckOutDay);
        }

        onInitPicker(['calendar-checkIn-flight', 'calendar-checkOut-flight'], vm.data.checkIn, vm.data.checkOut, 'checkIn', 'checkOut')
    }


    function onInitPicker(element, startDate, endDate, checkIn, checkOut) {
        const plugins = ["LockPlugin"]

        if (vm.data.mode) {
            plugins.push("RangePlugin");
        }
        var css = !setting.rb ? [`${config.cloudCdn}/assets/css/dist/${config.siteName}/booker.css?id=${+(new Date())}`] : [];
        _datePicker = {
            element: document.getElementById(element[0]),
            css: css,
            zIndex: 10,
            grid: 2,
            calendars: 768 <= window.innerWidth ? 2 : 1,
            autoApply: true,
            readonly: true,
            lang: config.culture,
            date: startDate,
            format: localeDatePicker.format,
            plugins: plugins,
            LockPlugin: {
                minDate: defaultDate,
                minDays: 1,
            },
            RangePlugin: {
                tooltip: true,
                startDate: startDate,
                endDate: endDate,
                tooltipNumber(num) {
                    return num;
                },
                locale: {
                    one: lang.day,
                    other: lang.days,
                }
            },
            setup(picker) {
                picker.on("render", (e) => {
                    const nextButtons = picker.ui.container.querySelectorAll(".calendars .next-button");
                    const prevButtons = picker.ui.container.querySelectorAll(".calendars .previous-button");
                    if (nextButtons) {
                        nextButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Siguiente mes');
                        });
                    }
                    if (prevButtons) {
                        prevButtons.forEach((button) => {
                            button.setAttribute('aria-label', 'Anterior mes');
                        });
                    }
                });
                picker.on('select', (e) => {

                    const { start, end, date } = e.detail;

                    if (vm.data.mode) {
                        vm.data[checkIn] = start.toJSDate();
                        vm.data[checkOut] = end.toJSDate();
                    } else {
                        vm.data[checkIn] = date.toJSDate();
                    }
                });
            },
        };

        if (_picker) {
            _picker.destroy();
        }
        _picker = new easepick.create(_datePicker);
    }

    function getUserSelectionParams() {
        let params = fn.search();

        let data = {}

        let placeOrigin = _placeOrigin;
        let placeDestination = _placeDestination;


        data.place_name = placeOrigin.DisplayText || "";
        data.place_name_to = placeDestination.DisplayText || "";

        data.place_selected = placeOrigin;
        data.place_selected_to = placeDestination;

        data.checkIn = params.startingFromDateTime || vm.data.checkIn;
        data.checkOut = params.returningFromDateTime || vm.data.checkOut;
        data.mode = (params.tripMode ? (params.mode === "1") : vm.data.mode);

        let box = window.__pt && window.__pt.box;
        data.paxes = (box && box.paxes) ? box.paxes : vm.data.paxes;

        return data;
    }

    function initialDefaultDate() {
        vm.data.checkIn = getInitialDate(defaultDate);
        vm.data.checkOut = getInitialDate(defaultDate, config.bookerDefaultCheckInDay + config.bookerDefaultCheckOutDay);
    }

    function getInitialDate(date = fn.getDate(), value = config.bookerDefaultCheckInDay) {
        let dateNew = fn.getDate(fn.formatDate(date, setting.formatDate));
        dateNew.setDate(dateNew.getDate() + value)
        return dateNew;
    }


    function updateInputPaxes() {

        let adults = 0;
        let children = 0;
        let lengthPax = vm.data.paxes.length;
        for (let index = 0; index < lengthPax; index++) {
            const paxes = vm.data.paxes[index];
            adults += paxes.adults;
            children += paxes.children.length;
        }

        const roomTitle = lengthPax == 1 ? lang.room : lang.rooms;
        const adultsTitle = adults == 1 ? lang.adult : lang.adults;
        const childrenTitle = children == 1 ? lang.child : lang.children;
        let childrenText = "";
        if (children > 0) {
            childrenText = `, ${children} ${childrenTitle}`;
        }
        vm.data.paxes_name = `${adults} ${adultsTitle}${childrenText}`;
        vm.data.paxes_people = adults + children;
        vm.data.capacityTotal = adults + children;
    }


    function isValidPax(pax, form) {
        let valid = true;
        let rooms = pax.length;

        for (let i = 0; i < rooms; i++) {
            const room = pax[i];

            let childrens = room.children.length;
            for (let c = 0; c < childrens; c++) {
                let inputKid = form[`children_${i}_${c}`];
                if (inputKid.$invalid) {
                    valid = false;
                    break;
                }
            }

            if (!valid) {
                break;
            }
        }

        return valid;
    }


    function isValidDate(dateFrom, dateTo) {
        let valid = true;

        dateFrom.setHours(0, 0, 0, 0);

        if (+dateFrom > +dateTo) {
            valid = false;
        }
        return valid;
    }

    function onFocusElement(nameDiv) {
        setTimeout(() => {
            let element = nameDiv && document.getElementById(nameDiv);
            if (element) {
                element.focus();
            }
        }, 200)

    }

    function setValidation(prop) {
        if (prop == 'paxes') {
            vm.validation.paxes = isValidPax(vm.data.paxes, vm.form);
        }
    }

    function somePaxHasError() {
        if (vm.data && vm.data.paxes && vm.data.paxes.length) {
            for (let a = 0; a < vm.data.paxes.length; a++) {
                let pax = vm.data.paxes[a];
                if (pax && pax.children) {
                    if (pax.children.some(child => child.year === null && child.year === undefined)) {
                        return true;
                    }
                }
            }
        }
        return false;
    }

    function getSearchHistory() {
        vm.history = SearchHistory.getFlight("F");
        ['from', 'to'].forEach(key => {
            vm.history[key]?.forEach(item => {
                item.displayDestinationHtml = stripHtml(item.displayDestinationHtml);
                item.code = stripHtml(item.code);
            });
        });
    }

    function analyticsAlgolia(item, index, type) {
        internal.setDataArgolia(item, index, type);
    }
    function getAnalyticsTags() {
        var arrTags = [];
        if (fn.mobileAndTabletCheck()) {
            arrTags.push("web_mobile");
        } else {
            arrTags.push("web_desktop");
        }
        var pathName = _globalUtil.getFirstPathSegment();
        if (pathName == "hotel") {
            arrTags.push("detail");
        } else if (pathName == "hoteles" || pathName == "hotels") {
            arrTags.push("list");
        } else if (setting.page == 'landings') {
            arrTags.push("landings");
        } else {
            arrTags.push("home");
        }
        return arrTags.join(',');
    }

    vm.handleCloseSuggestions = function(suffix) {
        if (suffix != undefined) {
            var item = vm.data[`place_selected${suffix}`];
            var place_name = item ? `${item.displayText} - ${item.displayDestinationHtml} (${item.code})` : "";
            if (vm.data[`place_name${suffix}`] != place_name) {
                vm.data[`place_name${suffix}`] = ""
                vm.data[`place_selected${suffix}`] = null;
            }
        }
    };

    function stripHtml(html) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }
    
    init();
}
